import { memo } from 'react';
import ChevronIcon from '../../resources/icons/chevron.svg';

const MemoizedChevronIcon = memo(ChevronIcon);

export default MemoizedChevronIcon;